import { SavePage } from 'utils';

import React from 'react';

export const handleSelectSort = (e, navigate, info, getParams) => {
    const params = {
        ...info,
    };
    params.page = 1;
    params.skip = 0;
    if (e.target.value === 'All') {
        // const cleanList = {
        //     ...info
        // }
        delete params[e.target.name];
        if (getParams) {
            getParams(params);
        } else {
            SavePage(navigate, info, { ...params });
        }
    } else {
        if (!e.target.value) {
            // const filteredList = {
            //     ...info
            // }
            delete params[e.target.name];
            if (getParams) {
                getParams(params);
            } else {
                SavePage(navigate, info, { ...params });
            }
        } else {
            // const newObj = {
            //     ...info
            // }
            params[e.target.name] = e.target.value;
            if (getParams) {
                getParams(params);
            } else {
                SavePage(navigate, info, { ...params });
            }
        }
    }
};
export const handleSelectMultiple = (e, navigate, info, selected, getParams) => {
    const params = {
        ...info,
    };
    params.page = 1;
    params.skip = 0;

    const currentArray = selected?.length ? selected : info?.[e.target.name] ? info?.[e.target.name] : [];
    if (e.target.value === 'All') {
        params[e.target.name] = [];
        if (getParams) {
            getParams(params);
        } else {
            SavePage(navigate, info, { ...params });
        }
    } else {
        const currentValue = currentArray?.find((item) => item === e.target.value);

        if (currentValue) {
            params[e.target.name] = currentArray?.filter((item) => item !== e.target.value);
        } else {
            params[e.target.name] = [...currentArray, e.target.value];
        }
        if (getParams) {
            getParams(params);
        } else {
            SavePage(navigate, info, { ...params });
        }
    }
};
